var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12C10.5 12 10.3327 12.0057 9.9896 12C7.01526 12.0452 4.44946 14.3219 4.018 17.2897H4.01419C3.94546 17.7549 4.12873 18.175 4.51436 18.4416C6.21175 19.6094 8.50613 20.1209 10.7258 19.976",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 21C17.9853 21 20 18.9853 20 16.5C20 14.0147 17.9853 12 15.5 12C13.0147 12 11 14.0147 11 16.5C11 18.9853 13.0147 21 15.5 21ZM17.9179 15.2915C18.0789 15.0672 18.0276 14.7548 17.8032 14.5938C17.5789 14.4328 17.2665 14.4841 17.1055 14.7085L14.9911 17.6548L13.9 16.2C13.7343 15.9791 13.4209 15.9343 13.2 16.1C12.9791 16.2657 12.9343 16.5791 13.1 16.8L14.6 18.8C14.6955 18.9274 14.846 19.0016 15.0053 19C15.1645 18.9983 15.3134 18.9209 15.4062 18.7915L17.9179 15.2915Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorker);
export default __webpack_public_path__ + "static/media/worker.3d496b1ce39d7667b33953bf3ca24b14.svg";
export { ForwardRef as ReactComponent };